var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/loader",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "loading",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7142623,0 C14.9252959,0 14.2856763,0.610545683 14.2856763,1.36364968 L14.2856763,6.81818981 C14.2856763,7.57129381 14.9252959,8.18183949 15.7142623,8.18183949 C16.5032288,8.18183949 17.1428484,7.57129381 17.1428484,6.81818981 L17.1428484,1.36364968 C17.1428484,0.610545683 16.5032288,0 15.7142623,0 Z",
    id: "Path",
    fill: "#2D50A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7143851,21.8181605 C14.9254186,21.8181605 14.2857991,22.4287062 14.2857991,23.1818102 L14.2857991,28.6363503 C14.2857991,29.3894543 14.9254186,30 15.7143851,30 C16.5033516,30 17.1429711,29.3894543 17.1429711,28.6363503 L17.1429711,23.1818102 C17.1429711,22.4287062 16.5033516,21.8181605 15.7143851,21.8181605 Z",
    id: "Path",
    fill: "#73A1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6635388,8.25045264 L6.62288635,4.39335079 C6.0651528,3.86079324 5.16060058,3.86079324 4.6026215,4.39335079 C4.0447038,4.92590835 4.0447038,5.78928557 4.6026215,6.32178453 L8.64327397,10.1788864 C8.92220212,10.4451358 9.28786564,10.5783192 9.65334501,10.5783192 C10.0188858,10.5783192 10.3846107,10.4451358 10.6634161,10.1788864 C11.2214565,9.64632882 11.2214565,8.78301019 10.6635388,8.25045264 Z",
    id: "Path",
    fill: "#355EC9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.346655, 13.636321)",
    fill: "#C4D9FD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22475897,3.33066257e-15 L5.36764826,3.33066257e-15 C4.5786818,3.33066257e-15 3.93906222,0.610545683 3.93906222,1.36364968 C3.93906222,2.11675368 4.5786818,2.72729936 5.36764826,2.72729936 L8.22475897,2.72729936 C9.01372543,2.72729936 9.65334501,2.11675368 9.65334501,1.36364968 C9.65334501,0.610545683 9.01372543,3.33066257e-15 8.22475897,3.33066257e-15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43865709,6.1849098 C1.88086216,5.65235224 0.976309932,5.65246943 0.418392236,6.1849098 C-0.139525461,6.71746735 -0.139402693,7.58078598 0.418392236,8.11334353 L4.45916747,11.9702696 C4.73809563,12.2365191 5.10375915,12.3696438 5.46936128,12.3696438 C5.83496342,12.3696438 6.20062693,12.2364605 6.47943232,11.9702696 C7.03735002,11.437712 7.03735002,10.5743348 6.47943232,10.0418359 L2.43865709,6.1849098 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.57145488,14.9999707 C8.57145488,14.2468667 7.93183529,13.636321 7.14286884,13.636321 L1.42858604,13.636321 C0.639619584,13.636321 1.74463359e-15,14.2468667 1.74463359e-15,14.9999707 C1.74463359e-15,15.7530747 0.639619584,16.3636204 1.42858604,16.3636204 L7.14286884,16.3636204 C7.93183529,16.3636204 8.57145488,15.7530747 8.57145488,14.9999707 Z",
    id: "Path",
    fill: "#3D6DEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6635388,19.8212308 C10.1057439,19.2886733 9.20113028,19.2886733 8.64327397,19.8212308 L4.60268288,23.6781569 C4.04476519,24.2105972 4.04476519,25.0740917 4.60268288,25.6065906 C4.88161104,25.8728401 5.24727456,26.0059648 5.61287669,26.0059648 C5.97847883,26.0059648 6.34414235,25.8728987 6.62294773,25.6065906 L10.6635388,21.7496646 C11.2214565,21.2172242 11.2214565,20.3537884 10.6635388,19.8212308 Z",
    id: "Path",
    fill: "#5286FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.a20dfc79.svg";
export { ForwardRef as ReactComponent };